import { combineReducers } from 'redux';
import { persistReducer, createMigrate } from 'redux-persist';
import localforage from 'localforage';
import globalReducer from './globalReducer';
import authReducer from './authReducer';
import apiReducer from './apiReducer';
import inventoryReducer from './inventoryReducer';
import inventory2Reducer from './inventory2Reducer';

const storage = localforage.createInstance({
  name: 'radian_store', // Should be alphanumeric, with underscores.
  version: 1,
});

const authPersistConfig = {
  key: 'auth',
  storage,
  version: 1,
  migrate: createMigrate({
    // @ts-ignore
    1: () => ({}),
  }),
};

const globalPersistConfig = {
  key: 'globals',
  storage,
  version: 0,
};

// const inventoryPersistConfig = {
//   key: 'inventory',
//   storage,
//   version: 1,
//   whitelist: ['filters', 'dateRange', 'data', 'lastFetched'], // Only persist these fields
// };

// const inventory2PersistConfig = {
//   key: 'inventory2',
//   storage,
//   version: 1,
//   whitelist: ['filters', 'dateRange', 'data', 'lastFetched'], // Only persist these fields
// };

// key will be data property on state obj
const rootReducer = combineReducers({
  apiCache: apiReducer,
  auth: persistReducer(authPersistConfig, authReducer),
  globals: persistReducer(globalPersistConfig, globalReducer),
  // inventory: persistReducer(inventoryPersistConfig, inventoryReducer),
  inventory: inventoryReducer,
  // inventory2: persistReducer(inventory2PersistConfig, inventory2Reducer),
  inventory2: inventory2Reducer,
});

export default rootReducer;
